
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { computed, defineComponent, reactive, ref, watch } from 'vue'
import { TASK_STATUS_OPTIONS, ERROR_MESSAGE, CloudFeatureOfflineLibraryService } from './../cloud.service'
import { ElMessage } from 'element-plus'
import UploadDialog from './upload-dialog/upload-dialog.vue'
import { getBaseUrl } from '@/common/const/api-base-url'
import { i18n } from '@/i18n'

function getSaasHost () {
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:'

  if (process.env.TEST || process.env.NODE_ENV === 'development') {
    return `${protocol}//team-supervise.testcluster-k8s-01.iweikan.cn`
  }

  return `${protocol}//team-admin.duba.net`
}

export default defineComponent({
  name: 'CloudFeatureOfflineLibrary',
  components: {
    UploadDialog
  },
  props: {
    type: {
      type: Boolean,
      default: true
    }
  },
  setup (props, ctx) {
    const injector = useReflectiveInjector([CloudFeatureOfflineLibraryService])
    const cloudFeatureOfflineLibraryService = injector.get(CloudFeatureOfflineLibraryService)
    const updateUrlNode = ref()
    const uploadNode = ref()
    let buildingTimer: any = null

    const viewModel = reactive({
      saasBaseUrl: getSaasHost(),
      token: '',
      lastBuildTime: 0,
      lastUpdateTime: 0,
      download_url: '',
      buildingLicense: false,
      uploadDialog: false,
      uploading: TASK_STATUS_OPTIONS.IDLE,
      uploadFile: null,
      errorMsg: '',
      fileName: '',
      percentage: 0,
    })

    function clipboard (node: Node) {
      if (!node) {
        return
      }

      const range = document.createRange()
      range.selectNodeContents(node)
      const selection = document.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      ElMessage.success(i18n.global.t('common.copySuccess'))
    }

    function resetFormData () {
      uploadNode.value.clearFiles()
      viewModel.fileName = ''
      viewModel.uploadFile = null
      viewModel.percentage = 0
    }

    function showUploadDialog () {
      viewModel.uploadDialog = true
      viewModel.uploading = TASK_STATUS_OPTIONS.RUNNING
    }

    function hideUploadDialog () {
      viewModel.uploadDialog = false
      resetFormData()
    }

    function getData () {
      cloudFeatureOfflineLibraryService.getAuthorization().then(response => {
        viewModel.lastBuildTime = response.authorization_last_time
        viewModel.lastUpdateTime = response.update_sample_last_time
        viewModel.token = response.token
        viewModel.download_url = response.download_url
    })
  }
    getData()
    const isLocal = ref(props.type)
    watch(() => props.type, (nv) => {
      isLocal.value = nv
    }, {
      immediate: true
    })
    return {
      type: isLocal,
      TASK_STATUS_OPTIONS,
      getBaseUrl,
      updateUrlNode,
      uploadNode,
      viewModel,
      handleBuildLicenseFile () {
        buildingTimer = setTimeout(() => {
          viewModel.buildingLicense = true
        // eslint-disable-next-line no-magic-numbers
        }, 300)
        cloudFeatureOfflineLibraryService.createAuthorization()
          .then(response => {
            if (response.resp_common?.ret) {
              ElMessage.error(ERROR_MESSAGE[response.resp_common.ret] || '授权文件生成失败')
              return
            }

            getData()
            ElMessage.success('授权文件生成成功')
          })
          .catch(error => {
            ElMessage.error(ERROR_MESSAGE[error.responseBody?.ret] || '授权文件生成失败')
          })
          .finally(() => {
            clearTimeout(buildingTimer)
            viewModel.buildingLicense = false
          })
      },
      handleDownLicenseFile () {
        cloudFeatureOfflineLibraryService.downloadAuthorizationFile()
      },
      handleCopyUpdateUrl () {
        clipboard(updateUrlNode.value)
      },
      uploadDone () {
        viewModel.uploadDialog = false
        resetFormData()
        getData()
        if (viewModel.uploading === TASK_STATUS_OPTIONS.SUCCESS) {
          ElMessage.warning('正在更新中，请稍等。')
        }
      },
      resetUpload () {
        viewModel.uploadDialog = false
        resetFormData()
      },
      handleHttpUpload () {
        const data = new FormData()
        data.append('file', viewModel.uploadFile?.raw)
        data.append('token', viewModel.token)
        showUploadDialog()
        cloudFeatureOfflineLibraryService[isLocal.value ? 'updateUpload':'offLineUpdateUpload'](data, (progress: any) => {
          // eslint-disable-next-line no-magic-numbers
          viewModel.percentage = Math.floor((progress.loaded / progress.total) * 100)
        }).then(response => {
          if (response.resp_common?.ret) {
            viewModel.uploading = TASK_STATUS_OPTIONS.FAIL
            viewModel.errorMsg = ERROR_MESSAGE[response.resp_common.ret] || response.resp_common.msg
            return
          }
          if(response.resp_common.ret === 0){
            ctx.emit('refresh')
          }
          getData()
          viewModel.uploading = TASK_STATUS_OPTIONS.SUCCESS
          setTimeout(() => {
            hideUploadDialog()
            // eslint-disable-next-line no-magic-numbers
          }, 1000)
        }).catch(() => {
          viewModel.uploading = TASK_STATUS_OPTIONS.FAIL
          viewModel.errorMsg = '病毒库更新失败'
        })
      },
      handleSubmitUpload () {
        uploadNode.value.submit()
      },
      handleSelectFile () {
        uploadNode.value.$el.querySelector('input').click()
      },
      handleClick () {
        resetFormData()
      },
      handleChange (file: any) {
        if (file?.status === 'ready') {
          viewModel.uploadFile = file
          viewModel.fileName = file.name
          viewModel.percentage = 0
        }
      },
    }
  }
})
